import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';
import { IoIosWarning } from 'react-icons/io';

const SystemPartnerCard = ({ name }: { name: string | undefined }) => {
  const { t } = useTranslation();
  return (
    <Alert bgColor="purple.100">
      <AlertIcon color="purple.500" as={IoIosWarning} />
      <Box>
        <AlertTitle>{t(`workshop:system_partner.assigned_alert.title`)}</AlertTitle>
        <AlertDescription>
          <Trans i18nKey="workshop:system_partner.assigned_alert.description" values={{ systemPartnerName: name }} />
        </AlertDescription>
      </Box>
    </Alert>
  );
};

export default SystemPartnerCard;
